export default __webpack_public_path__ + "static/media/2022-07-01-FordPass-A3-brochure.668f0f9e.pdf";